import { Controller, useFormContext } from 'react-hook-form'

import {
  PickerFormControl,
  PickerFormControlSpaceIdProps,
} from '../EntityPicker/PickerFormControl.js'
import { FormFieldProps } from './typings.js'

export function FormSpaceIdPicker({
  name,
  validation,
  ...rest
}: Omit<FormFieldProps<PickerFormControlSpaceIdProps>, 'onChange' | 'value'>) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <PickerFormControl.SpaceIdPicker
          {...rest}
          name={name}
          invalid={!!error?.message}
          error={error?.message}
          value={value}
          onChange={value => {
            onChange(value)
          }}
        />
      )}
    />
  )
}
